import React from "react";

function Transcripts({ podcastData, handleChange }) {
  return (
    <>
      <h3 className="font-sans font-medium text-gray-700">
        Generate Transcripts
      </h3>
      <p className="mt-1 text-sm text-gray-500">
        Enabling this feature will generate transcripts for all new episodes as
        you upload your audio.
      </p>

      <div className="flex items-center gap-6 my-4">
        <label className="flex items-center gap-2 text-gray-700">
          <input
            className="text-purple-600"
            type="radio"
            value="1"
            checked={podcastData.transcripts_enabled === 1}
            onChange={() => handleChange("transcripts_enabled", 1)}
          />
          Yes
        </label>
        <label className="flex items-center gap-2 text-gray-700">
          <input
            className="text-purple-600"
            type="radio"
            value="0"
            checked={podcastData.transcripts_enabled === 0}
            onChange={() => handleChange("transcripts_enabled", 0)}
          />
          No
        </label>
      </div>
      <hr />
      <div
        className={`mt-4 ${
          podcastData.transcripts_enabled ? "" : "opacity-40"
        }`}
      >
        <h3 className="font-sans font-medium text-gray-700">
          Generate Chapters
        </h3>
        <p className="mt-1 text-sm text-gray-500">
          Enabling this feature will generate chapters for all new episodes as
          you upload your audio.
        </p>

        <div className="flex items-center gap-6 mt-4">
          <label className="flex items-center gap-2 text-gray-700">
            <input
              className="text-purple-600"
              type="radio"
              value="1"
              disabled={!podcastData.transcripts_enabled}
              checked={podcastData.chapters_enabled === 1}
              onChange={() => handleChange("chapters_enabled", 1)}
            />
            Yes
          </label>
          <label className="flex items-center gap-2 text-gray-700">
            <input
              className="text-purple-600"
              type="radio"
              disabled={!podcastData.transcripts_enabled}
              value="0"
              checked={podcastData.chapters_enabled === 0}
              onChange={() => handleChange("chapters_enabled", 0)}
            />
            No
          </label>
        </div>
      </div>
    </>
  );
}

export default Transcripts;
